import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class News extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      pushRight,
      innerRef,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'news section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'news-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'Production AI Systems',
      paragraph: 'End-to-end AI engineering work across enterprise chatbots, agentic workflows, automation platforms, and NLP systems — built and shipped in real production environments'
    };

    const sectionContent = [
      {
        title: "Enterprise Chatbots with Agentic AI",
        paragraph: "Designed and deployed production-grade LLM systems for knowledge-intensive domains, building RAG pipelines that enable accurate, source-grounded retrieval from proprietary data. Implemented agentic workflows supporting multi-step reasoning and task automation beyond standard Q&A — deployed in hybrid and on-premise environments under strict GDPR compliance.",
        cta: "Build a chatbot like this →",
      },
      {
        title: "Enterprise Workflow Automation with n8n",
        paragraph: "Led the company-wide introduction of an AI automation platform to orchestrate workflows across systems and teams, deploying and operating n8n on-premise using Docker and Kubernetes. Designed reusable workflows integrating APIs, databases, and LLM services, enabling teams to automate recurring processes at scale.",
        cta: "Automate your workflows →",
      },
      {
        title: "Internal LLM Knowledge System",
        paragraph: "Architected and deployed an LLM-powered internal knowledge assistant for company-wide information access, integrating LLMs with structured internal data through a retrieval-based architecture. Employees can query projects, processes, and documentation via natural language — replacing manual knowledge lookup workflows.",
        cta: "Build an internal AI assistant →",
      },
      {
        title: "LLM & Voice Interface for Robotics",
        paragraph: "Integrated LLM-based conversational capabilities into a mobile robotic platform, combining large language models with speech-to-text and text-to-speech systems to enable full voice interaction. Built on a ROS-based robotics architecture — one of the earliest applied examples of bridging LLMs with physical robotic systems.",
        cta: "Explore AI + Robotics →",
      },
      {
        title: "NLP Ranking System for Technical Proposals",
        paragraph: "Built a production NLP pipeline to automate the evaluation and ranking of engineering proposals for a consulting firm, fine-tuning a language model on domain-specific data. The system scores and ranks incoming proposals against historical outcomes and was delivered as a fully functional API that replaced a manual review workflow end-to-end.",
        cta: "Automate your evaluation process →",
      },
      {
        title: "Reinforcement Learning for Autonomous Robot Navigation",
        paragraph: "Developed a cloud-based reinforcement learning system for autonomous robot navigation, implementing PPO-based path planning using RLlib and TensorFlow to handle dynamic obstacle avoidance in real-world environments. Integrated with ROS for simulation and deployed using Docker and Kubernetes for scalable experimentation.",
        cta: "Discuss a similar project →",
      },
    ];
  
    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container" ref={this.props.innerRef}>
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content reveal-from-bottom" />
            <div className={tilesClasses}>
              { sectionContent.map((item, i) =>
              <div key={i} className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay={i * 100}>
                <div className="tiles-item-inner has-shadow" style={{ display: 'flex', flexDirection: 'column' }}>
                  <div className="news-item-content" style={{ flex: 1 }}>
                    <div className="news-item-body">
                      <h3 className="news-item-title h4 mt-0 mb-8">
                        { item.title }
                      </h3>
                      <p className="mb-16 text-sm">
                        { item.paragraph }
                      </p>
                    </div>
                  </div>
                  <div className="news-item-footer mt-auto pt-16 has-top-divider">
                    <a
                      href="mailto:contact@arnoldfreitas.com"
                      className="button button-primary button-wide-mobile button-sm"
                    >
                      { item.cta }
                    </a>
                  </div>
                </div>
              </div>
              ) }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

News.propTypes = propTypes;
News.defaultProps = defaultProps;

export default forwardRef((props, ref) => <News 
    innerRef={ref} {...props}
/>); ;